// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class SubscriptionDetails {
    'consolidation_key': string;
    'last_update': number;
    'balance': number;
    'automatic': boolean;
    'subscribe_all_editions': boolean;
    'subscription_eligibility_count': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "consolidation_key",
            "baseName": "consolidation_key",
            "type": "string",
            "format": ""
        },
        {
            "name": "last_update",
            "baseName": "last_update",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "balance",
            "baseName": "balance",
            "type": "number",
            "format": "double"
        },
        {
            "name": "automatic",
            "baseName": "automatic",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "subscribe_all_editions",
            "baseName": "subscribe_all_editions",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "subscription_eligibility_count",
            "baseName": "subscription_eligibility_count",
            "type": "number",
            "format": "int64"
        }    ];

    static getAttributeTypeMap() {
        return SubscriptionDetails.attributeTypeMap;
    }

    public constructor() {
    }
}

